<script lang="ts">
	import { cn } from '$utils/cn';

	const { class: className } = $props<{
		class?: string;
	}>();
</script>

<svg
	class={cn(className)}
	width="154"
	height="154"
	viewBox="0 0 154 154"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		d="M119.819 13H94.6121L87.6856 25H20.2205C34.3183 9.59873 54.592 0 76.9988 0C92.5874 0 107.379 4.65316 119.819 13ZM140.197 33H13.8033C8.70941 40.2952 4.91702 48.4454 2.62334 57H71.5469L78.4747 45H147.055C145.126 40.7817 142.827 36.7662 140.197 33ZM153.069 65H0.931445C-0.350989 73.1749 -0.269303 81.3458 0.931445 89H55.4065L62.3326 77H154C154 72.9177 153.682 68.9112 153.069 65ZM2.62285 97.0004C4.89076 105.459 8.6485 113.617 13.8038 121H39.2645L46.1922 109H147.055C148.813 105.16 150.265 101.149 151.377 97.0004H2.62285ZM20.2132 129C34.2653 144.354 54.5082 154 77 154C99.4816 154 119.712 144.366 133.787 129H20.2132Z"
		class="fill-black dark:fill-white"
	/>
</svg>
